import React from 'react';

const ThoughtEditor = ({ 
    value, 
    onChange, 
    styles, 
    isMobile 
}) => {
    return (
        <textarea
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="What are you thinking?"
            style={isMobile ? styles.composePage.mobile.textarea : styles.composePage.desktop.textarea}
            autoFocus
        />
    );
};

export default ThoughtEditor; 